/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateActionCommandControllerCreate201,
  CreateActionDto,
  FollowUpActionBackfillProjectionControllerBackfill200,
  FollowUpActionListResponseDto,
  FollowUpActionResponseDto,
  ListActionsByNurseryQueryControllerListByNurseryParams,
  ListActionsPageQueryControllerListPageParams,
  MarkOverdueActionsControllerMarkOverdueActions200,
  UpdateActionCommandControllerUpdate200,
  UpdateActionDto,
  UpdateActionStatusCommandControllerUpdateStatus200,
  UpdateActionStatusDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a new follow-up action
 */
export const createActionCommandControllerCreate = (
  createActionDto: CreateActionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateActionCommandControllerCreate201>({
    url: `/v1/follow-up-actions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createActionDto,
    signal,
  });
};

export const getCreateActionCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionCommandControllerCreate>>,
    TError,
    { data: CreateActionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionCommandControllerCreate>>,
  TError,
  { data: CreateActionDto },
  TContext
> => {
  const mutationKey = ["createActionCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionCommandControllerCreate>>,
    { data: CreateActionDto }
  > = (props) => {
    const { data } = props ?? {};

    return createActionCommandControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionCommandControllerCreate>>
>;
export type CreateActionCommandControllerCreateMutationBody = CreateActionDto;
export type CreateActionCommandControllerCreateMutationError = void;

/**
 * @summary Create a new follow-up action
 */
export const useCreateActionCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createActionCommandControllerCreate>>,
      TError,
      { data: CreateActionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createActionCommandControllerCreate>>,
  TError,
  { data: CreateActionDto },
  TContext
> => {
  return useMutation(
    getCreateActionCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Update the status of a follow-up action
 */
export const updateActionStatusCommandControllerUpdateStatus = (
  actionId: string,
  updateActionStatusDto: UpdateActionStatusDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateActionStatusCommandControllerUpdateStatus200>({
    url: `/v1/follow-up-actions/${actionId}/status`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateActionStatusDto,
    signal,
  });
};

export const getUpdateActionStatusCommandControllerUpdateStatusMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>
      >,
      TError,
      { actionId: string; data: UpdateActionStatusDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>>,
    TError,
    { actionId: string; data: UpdateActionStatusDto },
    TContext
  > => {
    const mutationKey = ["updateActionStatusCommandControllerUpdateStatus"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>
      >,
      { actionId: string; data: UpdateActionStatusDto }
    > = (props) => {
      const { actionId, data } = props ?? {};

      return updateActionStatusCommandControllerUpdateStatus(actionId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateActionStatusCommandControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>>
  >;
export type UpdateActionStatusCommandControllerUpdateStatusMutationBody =
  UpdateActionStatusDto;
export type UpdateActionStatusCommandControllerUpdateStatusMutationError = void;

/**
 * @summary Update the status of a follow-up action
 */
export const useUpdateActionStatusCommandControllerUpdateStatus = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>
      >,
      TError,
      { actionId: string; data: UpdateActionStatusDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateActionStatusCommandControllerUpdateStatus>>,
  TError,
  { actionId: string; data: UpdateActionStatusDto },
  TContext
> => {
  return useMutation(
    getUpdateActionStatusCommandControllerUpdateStatusMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Update follow-up action details
 */
export const updateActionCommandControllerUpdate = (
  actionId: string,
  updateActionDto: UpdateActionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateActionCommandControllerUpdate200>({
    url: `/v1/follow-up-actions/${actionId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateActionDto,
    signal,
  });
};

export const getUpdateActionCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>,
    TError,
    { actionId: string; data: UpdateActionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>,
  TError,
  { actionId: string; data: UpdateActionDto },
  TContext
> => {
  const mutationKey = ["updateActionCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>,
    { actionId: string; data: UpdateActionDto }
  > = (props) => {
    const { actionId, data } = props ?? {};

    return updateActionCommandControllerUpdate(actionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>
>;
export type UpdateActionCommandControllerUpdateMutationBody = UpdateActionDto;
export type UpdateActionCommandControllerUpdateMutationError = void;

/**
 * @summary Update follow-up action details
 */
export const useUpdateActionCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>,
      TError,
      { actionId: string; data: UpdateActionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateActionCommandControllerUpdate>>,
  TError,
  { actionId: string; data: UpdateActionDto },
  TContext
> => {
  return useMutation(
    getUpdateActionCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get a follow-up action by ID
 */
export const getActionByIdQueryControllerGetById = (
  actionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<FollowUpActionResponseDto>({
    url: `/v1/follow-up-actions/${actionId}`,
    method: "GET",
    signal,
  });
};

export const getGetActionByIdQueryControllerGetByIdQueryKey = (
  actionId: string,
) => {
  return [`/v1/follow-up-actions/${actionId}`] as const;
};

export const getGetActionByIdQueryControllerGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
  TError = void,
>(
  actionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetActionByIdQueryControllerGetByIdQueryKey(actionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>
  > = ({ signal }) => getActionByIdQueryControllerGetById(actionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: actionId !== null && actionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionByIdQueryControllerGetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>
>;
export type GetActionByIdQueryControllerGetByIdQueryError = void;

export function useGetActionByIdQueryControllerGetById<
  TData = Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
  TError = void,
>(
  actionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionByIdQueryControllerGetById<
  TData = Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
  TError = void,
>(
  actionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionByIdQueryControllerGetById<
  TData = Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
  TError = void,
>(
  actionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a follow-up action by ID
 */

export function useGetActionByIdQueryControllerGetById<
  TData = Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
  TError = void,
>(
  actionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionByIdQueryControllerGetById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionByIdQueryControllerGetByIdQueryOptions(
    actionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * System endpoint called by GCP Cloud Scheduler to check for follow-up actions that have passed their due date/time and mark them as overdue. This will trigger email notifications to nursery managers.
 * @summary Mark overdue follow-up actions (System Task)
 */
export const markOverdueActionsControllerMarkOverdueActions = (
  signal?: AbortSignal,
) => {
  return axiosClient<MarkOverdueActionsControllerMarkOverdueActions200>({
    url: `/v1/follow-up-actions/mark-overdue`,
    method: "POST",
    signal,
  });
};

export const getMarkOverdueActionsControllerMarkOverdueActionsMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["markOverdueActionsControllerMarkOverdueActions"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>
      >,
      void
    > = () => {
      return markOverdueActionsControllerMarkOverdueActions();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkOverdueActionsControllerMarkOverdueActionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>>
  >;

export type MarkOverdueActionsControllerMarkOverdueActionsMutationError = void;

/**
 * @summary Mark overdue follow-up actions (System Task)
 */
export const useMarkOverdueActionsControllerMarkOverdueActions = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markOverdueActionsControllerMarkOverdueActions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMarkOverdueActionsControllerMarkOverdueActionsMutationOptions(options),
    queryClient,
  );
};
/**
 * One-off, idempotent endpoint to populate the denormalised list-projection columns (listStatus, listCompletedAt, primaryCategoryId) for existing follow-up actions. Run once after deploying the Follow-up Actions page migration, before exposing the UI.
 * @summary Backfill the Follow-up Actions list projection (platform admin only)
 */
export const followUpActionBackfillProjectionControllerBackfill = (
  signal?: AbortSignal,
) => {
  return axiosClient<FollowUpActionBackfillProjectionControllerBackfill200>({
    url: `/v1/follow-up-actions/backfill-list-projection`,
    method: "POST",
    signal,
  });
};

export const getFollowUpActionBackfillProjectionControllerBackfillMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["followUpActionBackfillProjectionControllerBackfill"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
      >,
      void
    > = () => {
      return followUpActionBackfillProjectionControllerBackfill();
    };

    return { mutationFn, ...mutationOptions };
  };

export type FollowUpActionBackfillProjectionControllerBackfillMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
    >
  >;

export type FollowUpActionBackfillProjectionControllerBackfillMutationError =
  void;

/**
 * @summary Backfill the Follow-up Actions list projection (platform admin only)
 */
export const useFollowUpActionBackfillProjectionControllerBackfill = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof followUpActionBackfillProjectionControllerBackfill>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getFollowUpActionBackfillProjectionControllerBackfillMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * @summary List follow-up actions for a scheduled questionnaire
 */
export const listActionsBySqQueryControllerListBySq = (
  scheduledQuestionnaireId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<FollowUpActionResponseDto[]>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/follow-up-actions`,
    method: "GET",
    signal,
  });
};

export const getListActionsBySqQueryControllerListBySqQueryKey = (
  scheduledQuestionnaireId: string,
) => {
  return [
    `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/follow-up-actions`,
  ] as const;
};

export const getListActionsBySqQueryControllerListBySqQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
  TError = void,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListActionsBySqQueryControllerListBySqQueryKey(scheduledQuestionnaireId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>
  > = ({ signal }) =>
    listActionsBySqQueryControllerListBySq(scheduledQuestionnaireId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      scheduledQuestionnaireId !== null &&
      scheduledQuestionnaireId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionsBySqQueryControllerListBySqQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>
>;
export type ListActionsBySqQueryControllerListBySqQueryError = void;

export function useListActionsBySqQueryControllerListBySq<
  TData = Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
  TError = void,
>(
  scheduledQuestionnaireId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
          TError,
          Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsBySqQueryControllerListBySq<
  TData = Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
  TError = void,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
          TError,
          Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsBySqQueryControllerListBySq<
  TData = Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
  TError = void,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List follow-up actions for a scheduled questionnaire
 */

export function useListActionsBySqQueryControllerListBySq<
  TData = Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
  TError = void,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsBySqQueryControllerListBySq>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListActionsBySqQueryControllerListBySqQueryOptions(
    scheduledQuestionnaireId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all follow-up actions for a nursery
 */
export const listActionsByNurseryQueryControllerListByNursery = (
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
  signal?: AbortSignal,
) => {
  return axiosClient<FollowUpActionResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/follow-up-actions`,
    method: "GET",
    params,
    signal,
  });
};

export const getListActionsByNurseryQueryControllerListByNurseryQueryKey = (
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/follow-up-actions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListActionsByNurseryQueryControllerListByNurseryQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListActionsByNurseryQueryControllerListByNurseryQueryKey(
      nurseryId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>>
  > = ({ signal }) =>
    listActionsByNurseryQueryControllerListByNursery(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionsByNurseryQueryControllerListByNurseryQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>>
  >;
export type ListActionsByNurseryQueryControllerListByNurseryQueryError = void;

export function useListActionsByNurseryQueryControllerListByNursery<
  TData = Awaited<
    ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListActionsByNurseryQueryControllerListByNurseryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
          >,
          TError,
          Awaited<
            ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsByNurseryQueryControllerListByNursery<
  TData = Awaited<
    ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
          >,
          TError,
          Awaited<
            ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsByNurseryQueryControllerListByNursery<
  TData = Awaited<
    ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all follow-up actions for a nursery
 */

export function useListActionsByNurseryQueryControllerListByNursery<
  TData = Awaited<
    ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsByNurseryQueryControllerListByNurseryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listActionsByNurseryQueryControllerListByNursery>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListActionsByNurseryQueryControllerListByNurseryQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List follow-up actions for the Follow-up Actions page (server-side paginated)
 */
export const listActionsPageQueryControllerListPage = (
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
  signal?: AbortSignal,
) => {
  return axiosClient<FollowUpActionListResponseDto>({
    url: `/v1/nurseries/${nurseryId}/follow-up-actions/paginated`,
    method: "GET",
    params,
    signal,
  });
};

export const getListActionsPageQueryControllerListPageQueryKey = (
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/follow-up-actions/paginated`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListActionsPageQueryControllerListPageQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListActionsPageQueryControllerListPageQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>
  > = ({ signal }) =>
    listActionsPageQueryControllerListPage(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionsPageQueryControllerListPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>
>;
export type ListActionsPageQueryControllerListPageQueryError = void;

export function useListActionsPageQueryControllerListPage<
  TData = Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListActionsPageQueryControllerListPageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
          TError,
          Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsPageQueryControllerListPage<
  TData = Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
          TError,
          Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListActionsPageQueryControllerListPage<
  TData = Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List follow-up actions for the Follow-up Actions page (server-side paginated)
 */

export function useListActionsPageQueryControllerListPage<
  TData = Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListActionsPageQueryControllerListPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActionsPageQueryControllerListPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListActionsPageQueryControllerListPageQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
